// extracted by mini-css-extract-plugin
export default {"Wrapper":"SubcontractsActions_Wrapper__ouycD"};